import {ChangeDetectionStrategy,Component,inject} from '@angular/core';
import {RouterLink} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {MatRippleModule} from '@angular/material/core';
import {environment} from '../../../../environments/environment';
import {AppService} from '../../../app.service';
import {ConsentService} from '../../../common/consent/consent.service';
import {PhoneFormatPipe} from '../../pipes/phone-format/phone-format.pipe';

@Component({
	selector:'app-footer',
	imports:[MatIconModule,MatRippleModule,RouterLink,PhoneFormatPipe],
	templateUrl:'./footer.html',
	styleUrl:'./footer.scss',
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class FooterComponent{
	protected readonly environment=environment;
	private readonly consentService=inject(ConsentService);
	readonly appService=inject(AppService);

	openCookieSettings():void{
		this.consentService.reopen();
	}
	
}
